import { render } from "./SecuritiesSummary.vue?vue&type=template&id=cf2a3146&scoped=true"
import script from "./SecuritiesSummary.vue?vue&type=script&lang=js"
export * from "./SecuritiesSummary.vue?vue&type=script&lang=js"

import "./SecuritiesSummary.vue?vue&type=style&index=0&id=cf2a3146&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf2a3146"]])

export default __exports__